import { BasicLayout } from '@/components/layouts';
import permissionConst from '@/utils/const/permission';

export default {
  path: '/data',
  name: 'Data',
  component: BasicLayout,
  redirectToChild: true,
  meta: {
    title: '统计',
    icon: 'iconcalendar',
    authorities: permissionConst.manager,
  },
  children: [
    // {
    //   path: '/data/list/table',
    //   name: 'Data.List.Table',
    //   component: () => import(/* webpackChunkName: "data" */ '@/views/modules/data/table/Index.vue'),
    //   meta: {
    //     title: '查询表格',
    //   },
    // },
    // {
    //   path: '/data/list/list',
    //   name: 'Data.List.List',
    //   component: () => import(/* webpackChunkName: "data" */ '@/views/modules/data/List.vue'),
    //   meta: {
    //     title: '分页列表',
    //   },
    // },
    // {
    //   path: '/data/chart',
    //   name: 'Data.Chart',
    //   component: () => import(/* webpackChunkName: "data" */ '@/views/modules/data/chart/Index.vue'),
    //   meta: {
    //     title: '图表',
    //   },
    // },
    {
      path: '/data/user-bind',
      name: 'Data.UserBind',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/data/UserBind.vue'),
      meta: {
        title: '用户绑定',
        icon: 'icon-yonghubangding',
      },
    },
    {
      path: '/data/api-request-statistics',
      name: 'Data.ApiRequestStatistics',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/data/ApiRequestStatistics.vue'),
      meta: {
        title: '接口调量',
        icon: 'icon-jiekoutiaoliang',
      },
    },
  ],
};
